// extracted by mini-css-extract-plugin
export default {"formContainer":"LoginForm_formContainer__HSTqx","form":"LoginForm_form__6AkqH","input":"LoginForm_input__uf2RQ","button":"LoginForm_button__a+YGt"};